// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__c4GXF","errorLogs":"EditorFooter_errorLogs__1ZIlY"};